const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

let headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
};

// report problem api
const ReportProblemAPI = async (
    accessToken: string, // access token
    websiteID: number, // website Id
    problemType: string, // problem
    media: File, // file
    description: string, //message
    t: Function,
    setValidationMessage: Function,
    setLoading: Function

): Promise<any> => {

    const url = `${baseURL}/free-version-report-problem`;
    const formData = new FormData();

    formData.append("website_id", websiteID.toString());
    formData.append("problem_type", problemType);
    formData.append("screenshot_file", media);
    formData.append("description", description);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
            body: formData
        });

        return await response;
    } catch (error) {
        // set error message
        setLoading(false);
        setValidationMessage(t("There was an error submitting the form. Please try again later"));
        return Promise.reject;
    }
}



export default ReportProblemAPI